import { createSlice } from '@reduxjs/toolkit'
import { resolveCreatedWith, AI_TOOL_IDS, resolveToolId, resolveToolIdFromPathname, ROUTES } from '../../utils/constants'

/**
 * Maps raw tool_name or tool_id from SSE payloads/API responses to:
 * 1. Normalized tool_name string
 * 2. User-friendly display title
 * 3. Target navigation route
 */
export const getToolMetadata = (toolIdentifier) => {
  if (!toolIdentifier) {
    return {
      tool_name: '',
      display_name: '',
      route: null,
      mediaType: null
    }
  }

  const raw = String(toolIdentifier).toLowerCase().trim()
  const cleaned = raw.replace(/[\s\-_]+/g, '_')
  const resolved = resolveCreatedWith(toolIdentifier) || cleaned

  const TOOL_MAP = {
    song_gen: {
      tool_name: 'song_gen',
      display_name: 'Make Me a Singer',
      route: ROUTES?.songGeneration || 'https://eu-dev.erosuniverse.com/ai-tool-v2/song-generation',
      mediaType: 'audio'
    },
    song_generation: {
      tool_name: 'song_gen',
      display_name: 'Make Me a Singer',
      route: ROUTES?.songGeneration || 'https://eu-dev.erosuniverse.com/ai-tool-v2/song-generation',
      mediaType: 'audio'
    },
    video_dubbing: {
      tool_name: 'video_dubbing',
      display_name: 'Dub My Video',
      route: ROUTES?.videoDubbing || 'https://eu-dev.erosuniverse.com/ai-tool-v2/video-dubbing',
      mediaType: 'video'
    },
    videodubbing: {
      tool_name: 'video_dubbing',
      display_name: 'Dub My Video',
      route: ROUTES?.videoDubbing || 'https://eu-dev.erosuniverse.com/ai-tool-v2/video-dubbing',
      mediaType: 'video'
    },
    text_to_image: {
      tool_name: 'text_to_image',
      display_name: 'Text to Image',
      route: '/ai-tool/text-to-image',
      mediaType: 'image'
    },
    texttoimage: {
      tool_name: 'text_to_image',
      display_name: 'Text to Image',
      route: '/ai-tool/text-to-image',
      mediaType: 'image'
    },
    image_gen: {
      tool_name: 'text_to_image',
      display_name: 'Text to Image',
      route: '/ai-tool/text-to-image',
      mediaType: 'image'
    },
    imagegen: {
      tool_name: 'text_to_image',
      display_name: 'Text to Image',
      route: '/ai-tool/text-to-image',
      mediaType: 'image'
    },
    img_gen: {
      tool_name: 'text_to_image',
      display_name: 'Text to Image',
      route: '/ai-tool/text-to-image',
      mediaType: 'image'
    },
    image_generation: {
      tool_name: 'text_to_image',
      display_name: 'Text to Image',
      route: '/ai-tool/text-to-image',
      mediaType: 'image'
    },
    imagegeneration: {
      tool_name: 'text_to_image',
      display_name: 'Text to Image',
      route: '/ai-tool/text-to-image',
      mediaType: 'image'
    },
    'image-generation': {
      tool_name: 'text_to_image',
      display_name: 'Text to Image',
      route: '/ai-tool/text-to-image',
      mediaType: 'image'
    },
    'image-gen': {
      tool_name: 'text_to_image',
      display_name: 'Text to Image',
      route: '/ai-tool/text-to-image',
      mediaType: 'image'
    },
    text_to_img: {
      tool_name: 'text_to_image',
      display_name: 'Text to Image',
      route: '/ai-tool/text-to-image',
      mediaType: 'image'
    },
    text2image: {
      tool_name: 'text_to_image',
      display_name: 'Text to Image',
      route: '/ai-tool/text-to-image',
      mediaType: 'image'
    },
    txt2img: {
      tool_name: 'text_to_image',
      display_name: 'Text to Image',
      route: '/ai-tool/text-to-image',
      mediaType: 'image'
    },
    generate_image: {
      tool_name: 'text_to_image',
      display_name: 'Text to Image',
      route: '/ai-tool/text-to-image',
      mediaType: 'image'
    },
    text_to_video: {
      tool_name: 'text_to_video',
      display_name: 'Text to Video',
      route: '/ai-tool/text-to-video',
      mediaType: 'video'
    },
    texttovideo: {
      tool_name: 'text_to_video',
      display_name: 'Text to Video',
      route: '/ai-tool/text-to-video',
      mediaType: 'video'
    },
    video_gen: {
      tool_name: 'text_to_video',
      display_name: 'Text to Video',
      route: '/ai-tool/text-to-video',
      mediaType: 'video'
    },
    videogen: {
      tool_name: 'text_to_video',
      display_name: 'Text to Video',
      route: '/ai-tool/text-to-video',
      mediaType: 'video'
    },
    video_generation: {
      tool_name: 'text_to_video',
      display_name: 'Text to Video',
      route: '/ai-tool/text-to-video',
      mediaType: 'video'
    },
    videogeneration: {
      tool_name: 'text_to_video',
      display_name: 'Text to Video',
      route: '/ai-tool/text-to-video',
      mediaType: 'video'
    },
    'video-generation': {
      tool_name: 'text_to_video',
      display_name: 'Text to Video',
      route: '/ai-tool/text-to-video',
      mediaType: 'video'
    },
    'video-gen': {
      tool_name: 'text_to_video',
      display_name: 'Text to Video',
      route: '/ai-tool/text-to-video',
      mediaType: 'video'
    },
    text_to_vid: {
      tool_name: 'text_to_video',
      display_name: 'Text to Video',
      route: '/ai-tool/text-to-video',
      mediaType: 'video'
    },
    text2video: {
      tool_name: 'text_to_video',
      display_name: 'Text to Video',
      route: '/ai-tool/text-to-video',
      mediaType: 'video'
    },
    txt2vid: {
      tool_name: 'text_to_video',
      display_name: 'Text to Video',
      route: '/ai-tool/text-to-video',
      mediaType: 'video'
    },
    generate_video: {
      tool_name: 'text_to_video',
      display_name: 'Text to Video',
      route: '/ai-tool/text-to-video',
      mediaType: 'video'
    },
    image_to_video: {
      tool_name: 'image_to_video',
      display_name: 'Image to Video',
      route: '/ai-tool/image-to-video',
      mediaType: 'video'
    },
    imagetovideo: {
      tool_name: 'image_to_video',
      display_name: 'Image to Video',
      route: '/ai-tool/image-to-video',
      mediaType: 'video'
    },
    image2video: {
      tool_name: 'image_to_video',
      display_name: 'Image to Video',
      route: '/ai-tool/image-to-video',
      mediaType: 'video'
    },
    img2video: {
      tool_name: 'image_to_video',
      display_name: 'Image to Video',
      route: '/ai-tool/image-to-video',
      mediaType: 'video'
    },
    img_to_video: {
      tool_name: 'image_to_video',
      display_name: 'Image to Video',
      route: '/ai-tool/image-to-video',
      mediaType: 'video'
    },
    image_to_vid: {
      tool_name: 'image_to_video',
      display_name: 'Image to Video',
      route: '/ai-tool/image-to-video',
      mediaType: 'video'
    },
    img2vid: {
      tool_name: 'image_to_video',
      display_name: 'Image to Video',
      route: '/ai-tool/image-to-video',
      mediaType: 'video'
    },
    background_change: {
      tool_name: 'background_change',
      display_name: 'Background Change',
      route: '/ai-tool/scene-swap',
      mediaType: 'image'
    },
    scene_swap: {
      tool_name: 'background_change',
      display_name: 'Background Change',
      route: '/ai-tool/scene-swap',
      mediaType: 'image'
    },
    sceneswap: {
      tool_name: 'background_change',
      display_name: 'Background Change',
      route: '/ai-tool/scene-swap',
      mediaType: 'image'
    },
    select_background: {
      tool_name: 'background_change',
      display_name: 'Background Change',
      route: '/ai-tool/scene-swap',
      mediaType: 'image'
    },
    colorize: {
      tool_name: 'colorize',
      display_name: 'Colorize',
      route: '/ai-tool/colorize',
      mediaType: 'image'
    },
    colorise: {
      tool_name: 'colorize',
      display_name: 'Colorize',
      route: '/ai-tool/colorize',
      mediaType: 'image'
    },
    black_white_colorize: {
      tool_name: 'colorize',
      display_name: 'Colorize',
      route: '/ai-tool/colorize',
      mediaType: 'image'
    },
    black_and_white_colorize: {
      tool_name: 'colorize',
      display_name: 'Colorize',
      route: '/ai-tool/colorize',
      mediaType: 'image'
    },
    color_mode_enhance: {
      tool_name: 'color_mode_enhance',
      display_name: 'Color Mode Enhance',
      route: '/ai-tool/colorize',
      mediaType: 'image'
    },
    motion_control: {
      tool_name: 'motion_control',
      display_name: 'Motion Control',
      route: '/ai-tool/motioncontrol',
      mediaType: 'video'
    },
    motioncontrol: {
      tool_name: 'motion_control',
      display_name: 'Motion Control',
      route: '/ai-tool/motioncontrol',
      mediaType: 'video'
    },
    face_swap: {
      tool_name: 'face_swap',
      display_name: 'Face Swap',
      route: '/ai-tool/face-swap',
      mediaType: 'image'
    },
    faceswap: {
      tool_name: 'face_swap',
      display_name: 'Face Swap',
      route: '/ai-tool/face-swap',
      mediaType: 'image'
    },
    'face-swap': {
      tool_name: 'face_swap',
      display_name: 'Face Swap',
      route: '/ai-tool/face-swap',
      mediaType: 'image'
    },
    video_face_swap: {
      tool_name: 'face_swap',
      display_name: 'Face Swap',
      route: '/ai-tool/face-swap',
      mediaType: 'video'
    },
    'video-face-swap': {
      tool_name: 'face_swap',
      display_name: 'Face Swap',
      route: '/ai-tool/face-swap',
      mediaType: 'video'
    },
    photo_avatar_talking: {
      tool_name: 'photo_avatar_talking',
      display_name: 'Talking Avatar',
      route: '/ai-tool/talkingAvatar',
      mediaType: 'video'
    },
    talking_avatar: {
      tool_name: 'photo_avatar_talking',
      display_name: 'Talking Avatar',
      route: '/ai-tool/talkingAvatar',
      mediaType: 'video'
    },
    talkingavatar: {
      tool_name: 'photo_avatar_talking',
      display_name: 'Talking Avatar',
      route: '/ai-tool/talkingAvatar',
      mediaType: 'video'
    },
    voice_cloning: {
      tool_name: 'voice_cloning',
      display_name: 'Voice Cloning',
      route: '/ai-tool/voiceClone',
      mediaType: 'audio'
    },
    voice_clone: {
      tool_name: 'voice_cloning',
      display_name: 'Voice Cloning',
      route: '/ai-tool/voiceClone',
      mediaType: 'audio'
    },
    voicecloning: {
      tool_name: 'voice_cloning',
      display_name: 'Voice Cloning',
      route: '/ai-tool/voiceClone',
      mediaType: 'audio'
    },
    voiceclone: {
      tool_name: 'voice_cloning',
      display_name: 'Voice Cloning',
      route: '/ai-tool/voiceClone',
      mediaType: 'audio'
    },
    voice_remix: {
      tool_name: 'voice_remix',
      display_name: 'Voice Remix',
      route: '/ai-tool/voice-remix',
      mediaType: 'audio'
    },
    voiceremix: {
      tool_name: 'voice_remix',
      display_name: 'Voice Remix',
      route: '/ai-tool/voice-remix',
      mediaType: 'audio'
    },
    remix_voice: {
      tool_name: 'voice_remix',
      display_name: 'Voice Remix',
      route: '/ai-tool/voice-remix',
      mediaType: 'audio'
    },
    action_generation: {
      tool_name: 'action_generation',
      display_name: 'Action Generation',
      route: '/ai-tool/actionGeneration',
      mediaType: 'video'
    },
    action_gen: {
      tool_name: 'action_generation',
      display_name: 'Action Generation',
      route: '/ai-tool/actionGeneration',
      mediaType: 'video'
    },
    actiongeneration: {
      tool_name: 'action_generation',
      display_name: 'Action Generation',
      route: '/ai-tool/actionGeneration',
      mediaType: 'video'
    },
    ...(AI_TOOL_IDS ? {
      [AI_TOOL_IDS.FACE_SWAP]: {
        tool_name: 'face_swap',
        display_name: 'Face Swap',
        route: '/ai-tool/face-swap',
        mediaType: 'image'
      },
      [AI_TOOL_IDS.COLORIZE]: {
        tool_name: 'colorize',
        display_name: 'Colorize',
        route: '/ai-tool/colorize',
        mediaType: 'image'
      },
      [AI_TOOL_IDS.SCENE_SWAP]: {
        tool_name: 'background_change',
        display_name: 'Scene Swap',
        route: '/ai-tool/scene-swap',
        mediaType: 'image'
      },
      [AI_TOOL_IDS.TEXT_TO_IMAGE]: {
        tool_name: 'text_to_image',
        display_name: 'Text to Image',
        route: '/ai-tool/text-to-image',
        mediaType: 'image'
      },
      [AI_TOOL_IDS.TEXT_TO_VIDEO]: {
        tool_name: 'text_to_video',
        display_name: 'Text to Video',
        route: '/ai-tool/text-to-video',
        mediaType: 'video'
      },
      [AI_TOOL_IDS.VOICE_CLONE]: {
        tool_name: 'voice_cloning',
        display_name: 'Voice Cloning',
        route: '/ai-tool/voiceClone',
        mediaType: 'audio'
      },
      [AI_TOOL_IDS.VOICE_REMIX]: {
        tool_name: 'voice_remix',
        display_name: 'Voice Remix',
        route: '/ai-tool/voice-remix',
        mediaType: 'audio'
      },
      [AI_TOOL_IDS.IMAGE_TO_VIDEO]: {
        tool_name: 'image_to_video',
        display_name: 'Image to Video',
        route: '/ai-tool/image-to-video',
        mediaType: 'video'
      },
      [AI_TOOL_IDS.ACTION_GENERATION]: {
        tool_name: 'action_generation',
        display_name: 'Action Generation',
        route: '/ai-tool/actionGeneration',
        mediaType: 'video'
      },
      [AI_TOOL_IDS.TALKING_AVATAR]: {
        tool_name: 'photo_avatar_talking',
        display_name: 'Talking Avatar',
        route: '/ai-tool/talkingAvatar',
        mediaType: 'video'
      },
      [AI_TOOL_IDS.MOTION_CONTROL]: {
        tool_name: 'motion_control',
        display_name: 'Motion Control',
        route: '/ai-tool/motioncontrol',
        mediaType: 'video'
      },
      [AI_TOOL_IDS.SONG_GENERATION]: {
        tool_name: 'song_gen',
        display_name: 'Make Me a Singer',
        route: ROUTES?.songGeneration || 'https://eu-dev.erosuniverse.com/ai-tool-v2/song-generation',
        mediaType: 'audio'
      },
      [AI_TOOL_IDS.VIDEO_DUBBING]: {
        tool_name: 'video_dubbing',
        display_name: 'Dub My Video',
        route: ROUTES?.videoDubbing || 'https://eu-dev.erosuniverse.com/ai-tool-v2/video-dubbing',
        mediaType: 'video'
      }
    } : {}),
    '13bc568d-bd0f-4d2a-bd97-fe88c6d47689': {
      tool_name: 'face_swap',
      display_name: 'Face Swap',
      route: '/ai-tool/face-swap',
      mediaType: 'image'
    },
    '7c60ba5d-7a4d-4fc5-a70b-a9fa91a39b30': {
      tool_name: 'colorize',
      display_name: 'Colorize',
      route: '/ai-tool/colorize',
      mediaType: 'image'
    },
    '93ee5d74-b3c6-4cdf-96ab-e1decb7a39f7': {
      tool_name: 'background_change',
      display_name: 'Scene Swap',
      route: '/ai-tool/scene-swap',
      mediaType: 'image'
    },
    'b0b14e70-e1c2-47b1-80ef-8f707dcfb045': {
      tool_name: 'text_to_image',
      display_name: 'Text to Image',
      route: '/ai-tool/text-to-image',
      mediaType: 'image'
    },
    '8d018a2a-667d-48d1-8f6b-566d51139945': {
      tool_name: 'text_to_video',
      display_name: 'Text to Video',
      route: '/ai-tool/text-to-video',
      mediaType: 'video'
    },
    '53e8d822-56c5-468a-adce-f1c8b1e6164f': {
      tool_name: 'voice_cloning',
      display_name: 'Voice Cloning',
      route: '/ai-tool/voiceClone',
      mediaType: 'audio'
    },
    'cba6ff0c-30e5-4568-b266-2c035eceb23b': {
      tool_name: 'voice_remix',
      display_name: 'Voice Remix',
      route: '/ai-tool/voice-remix',
      mediaType: 'audio'
    },
    '8329afcf-233f-479f-9a16-d58a0b0be627': {
      tool_name: 'image_to_video',
      display_name: 'Image to Video',
      route: '/ai-tool/image-to-video',
      mediaType: 'video'
    },
    '65ed7090-9979-41c0-bf5f-73223398dd53': {
      tool_name: 'action_generation',
      display_name: 'Action Generation',
      route: '/ai-tool/actionGeneration',
      mediaType: 'video'
    },
    '7e9c704c-abea-4b6f-8d1d-96edfbc5787f': {
      tool_name: 'photo_avatar_talking',
      display_name: 'Talking Avatar',
      route: '/ai-tool/talkingAvatar',
      mediaType: 'video'
    },
    '7e9c704c-abea-4b6f-8d1d-96edfbc578a3': {
      tool_name: 'motion_control',
      display_name: 'Motion Control',
      route: '/ai-tool/motioncontrol',
      mediaType: 'video'
    },
    '/ai-tool/voiceclone': {
      tool_name: 'voice_cloning',
      display_name: 'Voice Cloning',
      route: '/ai-tool/voiceClone',
      mediaType: 'audio'
    },
    '/ai-tool/voice-remix': {
      tool_name: 'voice_remix',
      display_name: 'Voice Remix',
      route: '/ai-tool/voice-remix',
      mediaType: 'audio'
    },
    '/ai-tool/image-to-video': {
      tool_name: 'image_to_video',
      display_name: 'Image to Video',
      route: '/ai-tool/image-to-video',
      mediaType: 'video'
    },
    '/ai-tool/text-to-image': {
      tool_name: 'text_to_image',
      display_name: 'Text to Image',
      route: '/ai-tool/text-to-image',
      mediaType: 'image'
    },
    '/ai-tool/text-to-video': {
      tool_name: 'text_to_video',
      display_name: 'Text to Video',
      route: '/ai-tool/text-to-video',
      mediaType: 'video'
    },
    '/ai-tool/scene-swap': {
      tool_name: 'background_change',
      display_name: 'Scene Swap',
      route: '/ai-tool/scene-swap',
      mediaType: 'image'
    },
    '/ai-tool/motioncontrol': {
      tool_name: 'motion_control',
      display_name: 'Motion Control',
      route: '/ai-tool/motioncontrol',
      mediaType: 'video'
    },
    '/ai-tool/talkingavatar': {
      tool_name: 'photo_avatar_talking',
      display_name: 'Talking Avatar',
      route: '/ai-tool/talkingAvatar',
      mediaType: 'video'
    },
    '/ai-tool/face-swap': {
      tool_name: 'face_swap',
      display_name: 'Face Swap',
      route: '/ai-tool/face-swap',
      mediaType: 'image'
    },
    '/ai-tool/colorize': {
      tool_name: 'colorize',
      display_name: 'Colorize',
      route: '/ai-tool/colorize',
      mediaType: 'image'
    },
    '/ai-tool/actiongeneration': {
      tool_name: 'action_generation',
      display_name: 'Action Generation',
      route: '/ai-tool/actionGeneration',
      mediaType: 'video'
    }
  }

  const toolIdFromPath = typeof toolIdentifier === 'string' && toolIdentifier.includes('/') ? resolveToolIdFromPathname(toolIdentifier) : null
  const toolId = resolveToolId(toolIdentifier) || toolIdFromPath

  if (toolId && TOOL_MAP[toolId]) return TOOL_MAP[toolId]
  if (TOOL_MAP[toolIdentifier]) return TOOL_MAP[toolIdentifier]
  if (TOOL_MAP[raw]) return TOOL_MAP[raw]

  const key = TOOL_MAP[resolved] ? resolved : TOOL_MAP[cleaned] ? cleaned : null

  if (key && TOOL_MAP[key]) {
    return TOOL_MAP[key]
  }

  // Smart fallback matching based on toolIdentifier string keywords
  if (cleaned.includes('voice_clone') || cleaned.includes('voiceclone')) {
    return {
      tool_name: 'voice_cloning',
      display_name: 'Voice Cloning',
      route: '/ai-tool/voiceClone',
      mediaType: 'audio'
    }
  }
  if (cleaned.includes('voice_remix') || cleaned.includes('voiceremix')) {
    return {
      tool_name: 'voice_remix',
      display_name: 'Voice Remix',
      route: '/ai-tool/voice-remix',
      mediaType: 'audio'
    }
  }
  if (cleaned.includes('color')) {
    return {
      tool_name: 'colorize',
      display_name: 'Colorize',
      route: '/ai-tool/colorize',
      mediaType: 'image'
    }
  }
  if (cleaned.includes('video') && cleaned.includes('face')) {
    return {
      tool_name: 'video_face_swap',
      display_name: 'Face Swap',
      route: '/ai-tool/face-swap',
      mediaType: 'video'
    }
  }
  if (cleaned.includes('face')) {
    return {
      tool_name: 'face_swap',
      display_name: 'Face Swap',
      route: '/ai-tool/face-swap',
      mediaType: 'image'
    }
  }
  if (cleaned.includes('scene') || cleaned.includes('background') || cleaned.includes('bg')) {
    return {
      tool_name: 'background_change',
      display_name: 'Background Change',
      route: '/ai-tool/scene-swap',
      mediaType: 'image'
    }
  }
  if (cleaned.includes('image_to_video') || cleaned.includes('imagetovideo')) {
    return {
      tool_name: 'image_to_video',
      display_name: 'Image to Video',
      route: '/ai-tool/image-to-video',
      mediaType: 'video'
    }
  }
  if (
    cleaned.includes('image_gen') ||
    cleaned.includes('imagegen') ||
    cleaned.includes('image_generation') ||
    cleaned.includes('imagegeneration') ||
    cleaned.includes('text_to_image') ||
    cleaned.includes('texttoimage') ||
    cleaned.includes('imagine') ||
    cleaned === 'tti'
  ) {
    return {
      tool_name: 'text_to_image',
      display_name: 'Text to Image',
      route: '/ai-tool/text-to-image',
      mediaType: 'image'
    }
  }
  if (cleaned.includes('video')) {
    return {
      tool_name: 'text_to_video',
      display_name: 'Text to Video',
      route: '/ai-tool/text-to-video',
      mediaType: 'video'
    }
  }
  if (cleaned.includes('image') || cleaned.includes('img')) {
    return {
      tool_name: 'text_to_image',
      display_name: 'Text to Image',
      route: '/ai-tool/text-to-image',
      mediaType: 'image'
    }
  }

  // Formatting fallback title
  const formattedName = raw
    .replace(/[_-]+/g, ' ')
    .replace(/\b\w/g, (l) => l.toUpperCase())

  return {
    tool_name: cleaned || 'ai_tool',
    display_name: formattedName || 'AI Tool',
    route: null,
    mediaType: null
  }
}

const JOBS_STORAGE_KEY = 'active_jobs_persist_v1'

const stripBlobUrl = (url) => {
  if (typeof url === 'string' && url.startsWith('blob:')) return null
  return url || null
}

const sanitizeJobForStorage = (job) => {
  if (!job || typeof job !== 'object') return job
  const sanitized = { ...job }
  sanitized.thumbnail_url = stripBlobUrl(sanitized.thumbnail_url)
  sanitized.input_image_url = stripBlobUrl(sanitized.input_image_url)
  sanitized.input_file_url = stripBlobUrl(sanitized.input_file_url)
  if (sanitized.meta && typeof sanitized.meta === 'object') {
    const meta = { ...sanitized.meta }
    meta.imagePreview = stripBlobUrl(meta.imagePreview)
    meta.firstImageUrl = stripBlobUrl(meta.firstImageUrl)
    if (meta.uploadedImageUrls && typeof meta.uploadedImageUrls === 'object') {
      meta.uploadedImageUrls = {
        ...meta.uploadedImageUrls,
        first: stripBlobUrl(meta.uploadedImageUrls.first),
        second: stripBlobUrl(meta.uploadedImageUrls.second)
      }
    }
    sanitized.meta = meta
  }
  return sanitized
}

const loadJobsFromStorage = () => {
  if (typeof window === 'undefined') return {}
  const hasAuth = Boolean(localStorage.getItem('access') || localStorage.getItem('user'))
  if (!hasAuth) return {}
  try {
    const raw = localStorage.getItem(JOBS_STORAGE_KEY)
    if (!raw) return {}
    const parsed = JSON.parse(raw)
    const now = Date.now()
    const valid = {}
    Object.keys(parsed).forEach((key) => {
      const job = parsed[key]
      if (
        job &&
        job.createdAt &&
        now - job.createdAt < 24 * 60 * 60 * 1000 &&
        !job.dismissed &&
        (job.status === 'processing' || job.status === 'queued')
      ) {
        valid[key] = sanitizeJobForStorage(job)
      }
    })
    return valid
  } catch (e) {
    return {}
  }
}

export const saveJobsToStorage = (activeJobs) => {
  if (typeof window === 'undefined') return
  try {
    const inProgressJobs = {}
    Object.keys(activeJobs || {}).forEach((key) => {
      const job = activeJobs[key]
      if (
        job &&
        (job.status === 'processing' || job.status === 'queued') &&
        !job.dismissed
      ) {
        inProgressJobs[key] = sanitizeJobForStorage(job)
      }
    })
    localStorage.setItem(JOBS_STORAGE_KEY, JSON.stringify(inProgressJobs))
  } catch (e) {
    console.error('Failed to save active jobs', e)
  }
}

const initialState = {
  activeJobs: loadJobsFromStorage(),
  isDrawerExpanded: false
}

const jobsSlice = createSlice({
  name: 'jobs',
  initialState,
  reducers: {
    registerJob: (state, action) => {
      const {
        jobId,
        generationId,
        tool_name,
        prompt,
        thumbnail_url,
        input_file_url,
        childIds = [],
        meta = {}
      } = action.payload

      const id = jobId || generationId
      if (!id) return

      const metaInfo = getToolMetadata(tool_name)

      state.activeJobs[id] = {
        jobId: id,
        generationId: id,
        tool_name: metaInfo.tool_name,
        display_name: metaInfo.display_name,
        mediaType: metaInfo.mediaType,
        targetUrl: `${metaInfo.route}?job_id=${id}`,
        status: 'queued', // queued | processing | completed | failed
        progress: 0,
        statusMessage: 'Queued for processing...',
        prompt: prompt || meta.prompt || '',
        thumbnail_url: thumbnail_url || meta.thumbnail_url || null,
        input_file_url: input_file_url || meta.input_file_url || null,
        input_video_url: action.payload?.input_video_url || meta.videoPreview || meta.uploadedVideoSignedUrl || null,
        input_image_url: action.payload?.input_image_url || meta.imagePreview || meta.uploadedImageSignedUrl || null,
        output_url: null,
        outputs: [],
        childIds: Array.isArray(childIds) ? childIds.filter((c) => c !== id).slice(0, meta.outputs || 4) : [],
        createdAt: Date.now(),
        updatedAt: Date.now(),
        dismissed: false,
        viewed: false,
        error: null,
        ...action.payload,
        meta: { ...meta, ...(action.payload?.meta || {}) }
      }
    },

    updateJobFromSSE: (state, action) => {
      const payload = action.payload || {}
      const {
        job_id,
        generation_id,
        generationId,
        jobId,
        parent_id,
        child_id,
        tool_name,
        ai_tool_name,
        ai_tool_id,
        status,
        event_type,
        progress,
        message,
        status_message,
        error,
        output_url,
        result_url,
        video_url,
        image_url,
        audio_url,
        signed_result_url,
        thumbnail_url,
        input_file_url,
        file_url,
        results
      } = payload

      const checkIds = [job_id, generation_id, generationId, jobId, parent_id, child_id].filter(Boolean)
      const incomingId = parent_id || generation_id || job_id || generationId || jobId
      if (checkIds.length === 0 && !tool_name && !ai_tool_id) return

      const isDetectionStep =
        payload.operation === 'template_detection' ||
        payload.operation === 'detect_target_face' ||
        payload.operation === 'new_face_detection' ||
        payload.process_status === 'TEMPLATE_COMPLETED' ||
        payload.process_status === 'TARGET_FACES_DETECTED' ||
        payload.process_status === 'READY_FOR_SWAP' ||
        (payload.message && String(payload.message).toLowerCase().includes('template upload successful')) ||
        (payload.status_message && String(payload.status_message).toLowerCase().includes('template upload successful')) ||
        (payload.statusMessage && String(payload.statusMessage).toLowerCase().includes('template upload successful')) ||
        (payload.message && String(payload.message).toLowerCase().includes('target locked')) ||
        (payload.status_message && String(payload.status_message).toLowerCase().includes('target locked')) ||
        (payload.statusMessage && String(payload.statusMessage).toLowerCase().includes('target locked')) ||
        (payload.message && String(payload.message).toLowerCase().includes('locked and ready')) ||
        (payload.status_message && String(payload.status_message).toLowerCase().includes('locked and ready')) ||
        (payload.statusMessage && String(payload.statusMessage).toLowerCase().includes('locked and ready')) ||
        Boolean(payload.target_face_urls || payload.signed_target_face_urls) ||
        Boolean(payload.detected_faces_urls || payload.signed_detected_face_urls || payload.detected_face_urls)

      if (isDetectionStep) {
        checkIds.forEach((id) => {
          if (state.activeJobs[id]) {
            delete state.activeJobs[id]
          }
        })
        return
      }

      // Robust matching for jobs registered on this client/device:
      // 1. Direct match by any ID in activeJobs keys
      let existingJob = null
      for (const id of checkIds) {
        if (state.activeJobs[id]) {
          existingJob = state.activeJobs[id]
          break
        }
      }

      // 2. Match by child_id, generationId, jobId, or parent_id properties inside job objects
      if (!existingJob) {
        existingJob = Object.values(state.activeJobs).find((j) => {
          return checkIds.some(
            (id) =>
              j.generationId === id ||
              j.jobId === id ||
              j.id === id ||
              j.parent_id === id ||
              (Array.isArray(j.childIds) && j.childIds.includes(id))
          )
        })
      }

      // If the job was not registered on this device, ignore the event
      if (!existingJob) return

      // Link child generation_id to existing parent job without exceeding expected outputs
      const isParentId = (cid) =>
        !cid ||
        cid === existingJob.id ||
        cid === existingJob.jobId ||
        cid === existingJob.generationId

      if (generation_id && !isParentId(generation_id)) {
        if (!existingJob.childIds) existingJob.childIds = []
        if (!existingJob.childIds.includes(generation_id)) {
          const maxOutputs = existingJob.meta?.outputs || 4
          const placeholderIndex = existingJob.childIds.findIndex((id) => id.includes('_child_'))
          if (placeholderIndex !== -1) {
            existingJob.childIds[placeholderIndex] = generation_id
          } else if (existingJob.childIds.length < maxOutputs) {
            existingJob.childIds.push(generation_id)
          }
        }
      }

      if ((input_file_url || file_url) && !existingJob.input_file_url) {
        existingJob.input_file_url = input_file_url || file_url
      }
      if (payload.input_video_url && !existingJob.input_video_url) {
        existingJob.input_video_url = payload.input_video_url
      }
      if (payload.input_image_url && !existingJob.input_image_url) {
        existingJob.input_image_url = payload.input_image_url
      }
      if (payload.prompt && !existingJob.prompt) {
        existingJob.prompt = payload.prompt
      }
      if (payload.meta) {
        existingJob.meta = { ...(existingJob.meta || {}), ...payload.meta }
      }
      const incomingContentId =
        payload.content_id ||
        payload.contentId ||
        payload.outputs?.[0]?.content_id ||
        payload.outputs?.[0]?.contentId ||
        (results && Array.isArray(results) && (results[0]?.content_id || results[0]?.contentId)) ||
        null
      if (incomingContentId) {
        existingJob.content_id = incomingContentId
      }

      existingJob.updatedAt = Date.now()

      // Process status / event_type
      const rawStatus = String(status || event_type || '').toUpperCase()

      if (message || status_message) {
        existingJob.statusMessage = message || status_message
      }

      // Check completion URLs
      const finalUrl =
        video_url ||
        result_url ||
        signed_result_url ||
        payload.signed_swap_url ||
        payload.swap_url ||
        payload.signed_url ||
        payload.file_url ||
        image_url ||
        audio_url ||
        payload.reference_audio_url ||
        payload.result_video_url ||
        (output_url && output_url !== existingJob.thumbnail_url ? output_url : null) ||
        (results && Array.isArray(results) && results[0]
          ? results[0].video_url ||
            results[0].output_url ||
            results[0].audio_url ||
            results[0].image_url ||
            results[0].signed_swap_url ||
            results[0].result_url ||
            results[0].signed_result_url
          : null)

      const hasDetectedFaces = Boolean(
        payload.detected_faces_urls ||
        payload.signed_detected_face_urls ||
        payload.detected_face_urls ||
        payload.target_face_urls ||
        payload.signed_target_face_urls ||
        payload.target_face_signed_urls ||
        payload.signed_target_urls ||
        payload.target_urls ||
        payload.signed_masked_face_urls ||
        payload.masked_face_urls ||
        payload.process_status === 'TARGET_FACES_DETECTED' ||
        payload.process_status === 'TEMPLATE_COMPLETED' ||
        payload.operation === 'detect_target_face' ||
        payload.operation === 'template_detection'
      )

      const isParentIdForChild = (cid) =>
        !cid ||
        cid === existingJob.id ||
        cid === existingJob.jobId ||
        cid === existingJob.generationId

      const rawCandidateChildId =
        (child_id && !isParentIdForChild(child_id) ? child_id : null) ||
        (parent_id && generation_id && !isParentIdForChild(generation_id) ? generation_id : null) ||
        (generation_id && !isParentIdForChild(generation_id) ? generation_id : null) ||
        (job_id && !isParentIdForChild(job_id) ? job_id : null)

      const targetChildId = rawCandidateChildId || null

      if (progress !== undefined && progress !== null) {
        let numericProg = typeof progress === 'number' ? progress : parseFloat(String(progress).replace('%', ''))
        if (!isNaN(numericProg)) {
          if (numericProg > 0 && numericProg <= 1.0) {
            numericProg = numericProg * 100
          }
          const effectiveProgress = (numericProg >= 100 && !finalUrl && !hasDetectedFaces && !isDetectionStep)
            ? 99
            : Math.round(numericProg)

          const expectedOutputs = existingJob.meta?.outputs || (Array.isArray(existingJob.childIds) && existingJob.childIds.length > 0 ? existingJob.childIds.length : 1)

          if (targetChildId) {
            if (!existingJob.childResults) existingJob.childResults = {}
            if (!existingJob.childResults[targetChildId]) {
              existingJob.childResults[targetChildId] = {
                id: targetChildId,
                progress: 0,
                status: 'processing'
              }
            }
            existingJob.childResults[targetChildId].progress = effectiveProgress
            if (message || status_message) {
              existingJob.childResults[targetChildId].statusMessage = message || status_message
            }

            if (expectedOutputs > 1) {
              let sum = 0
              if (existingJob.childIds && existingJob.childIds.length > 0) {
                existingJob.childIds.forEach((cId) => {
                  sum += (existingJob.childResults?.[cId]?.progress || 0)
                })
              } else {
                Object.values(existingJob.childResults).forEach((c) => {
                  sum += (c.progress || 0)
                })
              }
              existingJob.progress = Math.max(0, Math.min(99, Math.round(sum / Math.max(1, expectedOutputs))))
            } else {
              existingJob.progress = effectiveProgress
            }
          } else {
            existingJob.progress = effectiveProgress
          }
        }
      } else if (targetChildId && (message || status_message)) {
        if (!existingJob.childResults) existingJob.childResults = {}
        if (!existingJob.childResults[targetChildId]) {
          existingJob.childResults[targetChildId] = {
            id: targetChildId,
            progress: 0,
            status: 'processing'
          }
        }
        existingJob.childResults[targetChildId].statusMessage = message || status_message
      }

      // Check failure / rejection / moderation
      const rawJobStatus = String(payload.job_status || '').toUpperCase()
      const rawProcessStatus = String(payload.process_status || '').toUpperCase()

      const isPostgenNsfw =
        rawStatus === 'CHECK_POSTGEN_NSFW' ||
        rawProcessStatus === 'CHECK_POSTGEN_NSFW' ||
        rawJobStatus === 'CHECK_POSTGEN_NSFW' ||
        /check[_\s]postgen[_\s]nsfw/i.test(rawStatus) ||
        /check[_\s]postgen[_\s]nsfw/i.test(rawProcessStatus) ||
        /check[_\s]postgen[_\s]nsfw/i.test(rawJobStatus) ||
        /check[_\s]postgen[_\s]nsfw/i.test(message || '') ||
        /check[_\s]postgen[_\s]nsfw/i.test(status_message || '')

      const rawFailureText = `${payload.message || ''} ${payload.status_message || ''} ${payload.error_message || ''} ${payload.error || ''} ${error || ''} ${payload.primary_violation || ''} ${rawStatus} ${rawJobStatus} ${rawProcessStatus}`
      const fullFailureStr = rawFailureText.replace(/check[_\s]postgen[_\s]nsfw/gi, '')
      
      const isModerationPending =
        !isPostgenNsfw &&
        (
          rawStatus === 'MODERATION_PENDING' ||
          rawStatus === 'MODERATION_PENDING_REVIEW' ||
          rawStatus === 'MODERATING_PENDING' ||
          rawStatus === 'PENDING_REVIEW' ||
          rawJobStatus === 'MODERATION_PENDING' ||
          rawJobStatus === 'MODERATION_PENDING_REVIEW' ||
          rawJobStatus === 'MODERATING_PENDING' ||
          rawJobStatus === 'PENDING_REVIEW' ||
          rawProcessStatus === 'MODERATION_PENDING' ||
          rawProcessStatus === 'MODERATION_PENDING_REVIEW' ||
          rawProcessStatus === 'MODERATING_PENDING' ||
          rawProcessStatus === 'PENDING_REVIEW' ||
          /MODERAT(ION|ING)[_\s]PENDING|PENDING[_\s]REVIEW/i.test(rawStatus) ||
          /MODERAT(ION|ING)[_\s]PENDING|PENDING[_\s]REVIEW/i.test(rawProcessStatus) ||
          /MODERAT(ION|ING)[_\s]PENDING|PENDING[_\s]REVIEW/i.test(rawJobStatus) ||
          /moderation.*pending|pending.*review|under.*moderation/i.test(fullFailureStr)
        )

      const isRejected =
        !isPostgenNsfw &&
        (
          rawStatus === 'MODERATION_REJECTED' ||
          rawStatus === 'REJECTED' ||
          rawJobStatus === 'MODERATION_REJECTED' ||
          rawJobStatus === 'REJECTED' ||
          rawProcessStatus === 'MODERATION_REJECTED' ||
          rawProcessStatus === 'REJECTED' ||
          payload.moderation_passed === false ||
          payload.is_rejected === true ||
          payload.moderation_rejected === true ||
          /nsfw|moderation_rejected|inappropriate|failed moderation|celebrity|restricted public figures?|celebrity_content|restricted/i.test(fullFailureStr)
        )

      if (isPostgenNsfw) {
        existingJob.status = 'processing'
        existingJob.is_rejected = false
        existingJob.moderation_rejected = false
        existingJob.is_moderation = false
        existingJob.error = null
        if (message || status_message) {
          existingJob.statusMessage = message || status_message
        }
        if (targetChildId && existingJob.childResults?.[targetChildId]) {
          existingJob.childResults[targetChildId].status = 'processing'
          existingJob.childResults[targetChildId].error = null
          existingJob.childResults[targetChildId].is_rejected = false
          existingJob.childResults[targetChildId].is_moderation = false
        }
      } else if (
        rawStatus === 'FAILED' ||
        rawStatus === 'FAILURE' ||
        rawStatus === 'ERROR' ||
        rawJobStatus === 'FAILED' ||
        rawProcessStatus === 'FAILED' ||
        (payload.code >= 400 && payload.code < 600) ||
        (payload.status >= 400 && payload.status < 600) ||
        isRejected ||
        isModerationPending ||
        error
      ) {
        const errText = payload.message || payload.status_message || payload.error_message || payload.error || error || (isModerationPending ? 'Content is under moderation review' : 'Generation failed')
        const finalStatus = isRejected ? 'rejected' : isModerationPending ? 'moderation' : 'failed'
        if (targetChildId && existingJob.childResults) {
          existingJob.childResults[targetChildId] = {
            ...(existingJob.childResults[targetChildId] || {}),
            id: targetChildId,
            status: finalStatus,
            error: errText,
            is_rejected: isRejected,
            moderation_rejected: isRejected,
            is_moderation: isModerationPending
          }
        }
        existingJob.status = finalStatus
        existingJob.is_rejected = isRejected
        existingJob.moderation_rejected = isRejected
        existingJob.is_moderation = isModerationPending
        existingJob.error = errText
        existingJob.error_message = payload.error_message || existingJob.error_message
        existingJob.primary_violation = payload.primary_violation || existingJob.primary_violation
        existingJob.statusMessage = existingJob.error
        // Preserve dismissed state if already dismissed by user/cancel action
        existingJob.dismissed = Boolean(existingJob.dismissed)
        existingJob.viewed = Boolean(existingJob.viewed)
        existingJob.updatedAt = Date.now()
        saveJobsToStorage(state.activeJobs)
        return
      }

      const isExplicitCompleted =
        rawStatus === 'COMPLETED' ||
        rawStatus === 'SUCCESS' ||
        rawStatus === 'JOB_COMPLETED' ||
        rawStatus === 'FINISHED'

      if (hasDetectedFaces && !finalUrl) {
        const detectedArr = Array.isArray(payload.signed_detected_face_urls || payload.detected_faces_urls || payload.detected_face_urls)
          ? (payload.signed_detected_face_urls || payload.detected_faces_urls || payload.detected_face_urls)
          : Object.values(payload.signed_detected_face_urls || payload.detected_faces_urls || payload.detected_face_urls || {})
        existingJob.detected_face_urls = detectedArr
        existingJob.statusMessage = 'Faces detected'
        existingJob.updatedAt = Date.now()
      }

      // Mark completed ONLY if final output URL is present AND (explicit completion status OR 100% progress)
      if (finalUrl && (isExplicitCompleted || existingJob.progress >= 100 || (progress !== undefined && Number(progress) >= 100))) {
        if (targetChildId) {
          if (!existingJob.childResults) existingJob.childResults = {}
          existingJob.childResults[targetChildId] = {
            ...(existingJob.childResults[targetChildId] || {}),
            id: targetChildId,
            imageUrl: finalUrl,
            resultUrl: finalUrl,
            progress: 100,
            status: 'completed',
            statusMessage: 'Processing complete',
            thumbnail_url: thumbnail_url || null,
            content_id: payload.content_id || targetChildId,
            ai_tool_id: payload.ai_tool_id || null,
            orientation: payload.orientation || null,
            prompt: payload.prompt || null
          }
          existingJob.outputs = Object.values(existingJob.childResults)
        }

        const totalChildren = Array.isArray(existingJob.childIds) ? existingJob.childIds.length : (existingJob.meta?.outputs || 1)
        const completedChildrenCount = existingJob.childResults
          ? Object.values(existingJob.childResults).filter(r => r.resultUrl || r.imageUrl || r.status === 'completed').length
          : 0

        // If job has multiple children, only mark entire parent completed when all children complete
        if (totalChildren <= 1 || completedChildrenCount >= totalChildren) {
          existingJob.status = 'completed'
          existingJob.progress = 100
          existingJob.statusMessage = 'Processing complete'
          existingJob.output_url = finalUrl || (existingJob.outputs?.find(r => r.resultUrl || r.imageUrl)?.resultUrl)
          existingJob.error = null
          existingJob.error_message = null
          existingJob.is_rejected = false
          existingJob.moderation_rejected = false
          existingJob.is_moderation = false
          if (incomingContentId) {
            existingJob.content_id = incomingContentId
          }
          if (existingJob.content_id && (!existingJob.outputs || existingJob.outputs.length === 0)) {
            existingJob.outputs = [{
              output_url: existingJob.output_url,
              content_id: existingJob.content_id,
              status: 'completed'
            }]
          }
        } else {
          existingJob.status = 'processing'
          existingJob.progress = Math.round((completedChildrenCount / totalChildren) * 100)
        }

        if (thumbnail_url && !existingJob.thumbnail_url) existingJob.thumbnail_url = thumbnail_url
        if (results && Array.isArray(results)) existingJob.outputs = results
        existingJob.updatedAt = Date.now()
        saveJobsToStorage(state.activeJobs)
        return
      }

      // If status is explicit completed BUT output URL has not arrived yet (and not detect phase), keep status as processing capped at 99%
      if (
        isExplicitCompleted &&
        !finalUrl &&
        !hasDetectedFaces &&
        !payload.target_face_urls &&
        !payload.signed_target_face_urls &&
        payload.operation !== 'detect_target_face' &&
        payload.process_status !== 'TARGET_FACES_DETECTED'
      ) {
        existingJob.status = 'processing'
        if (existingJob.progress < 99) existingJob.progress = 99
        existingJob.statusMessage = 'Finalizing output...'
        existingJob.updatedAt = Date.now()
        saveJobsToStorage(state.activeJobs)
        return
      }

      // Update status for active jobs
      const effectiveStatus = String(payload.job_status || payload.process_status || rawStatus || '').toUpperCase()
      if (effectiveStatus === 'QUEUED' || rawStatus === 'QUEUED' || rawStatus === 'JOB_CREATED') {
        existingJob.status = 'queued'
      } else if (existingJob.status !== 'completed' && existingJob.status !== 'failed' && existingJob.status !== 'rejected' && existingJob.status !== 'moderation') {
        existingJob.status = 'processing'
      }
      existingJob.updatedAt = Date.now()
      saveJobsToStorage(state.activeJobs)
    },

    updateJobChild: (state, action) => {
      const { jobId, generationId, childId, resultUrl, imageUrl, progress, statusMessage, status, contentId, content_id, aiToolId, ai_tool_id, orientation, prompt, thumbnailUrl, thumbnail_url } = action.payload || {}
      const targetId = jobId || generationId
      if (!targetId || !childId) return

      let existingJob = state.activeJobs[targetId]
      if (!existingJob) {
        existingJob = Object.values(state.activeJobs).find(
          (j) => j.generationId === targetId || j.jobId === targetId || (Array.isArray(j.childIds) && j.childIds.includes(childId))
        )
      }
      if (!existingJob) return

      if (!existingJob.childResults) existingJob.childResults = {}
      const finalResultUrl = resultUrl || imageUrl || null
      existingJob.childResults[childId] = {
        ...(existingJob.childResults[childId] || {}),
        id: childId,
        imageUrl: finalResultUrl || existingJob.childResults[childId]?.imageUrl || null,
        resultUrl: finalResultUrl || existingJob.childResults[childId]?.resultUrl || null,
        progress: progress !== undefined ? progress : (existingJob.childResults[childId]?.progress ?? 0),
        statusMessage: statusMessage || existingJob.childResults[childId]?.statusMessage || '',
        status: status || (finalResultUrl ? 'completed' : (existingJob.childResults[childId]?.status || 'processing')),
        content_id: contentId || content_id || existingJob.childResults[childId]?.content_id || null,
        ai_tool_id: aiToolId || ai_tool_id || existingJob.childResults[childId]?.ai_tool_id || null,
        orientation: orientation || existingJob.childResults[childId]?.orientation || null,
        thumbnail_url: thumbnailUrl || thumbnail_url || existingJob.childResults[childId]?.thumbnail_url || null,
        prompt: prompt || existingJob.childResults[childId]?.prompt || null
      }

      existingJob.outputs = Object.values(existingJob.childResults)
      if (progress !== undefined && progress !== null) {
        let numericProg = typeof progress === 'number' ? progress : parseFloat(String(progress).replace('%', ''))
        if (!isNaN(numericProg)) {
          if (numericProg > 0 && numericProg <= 1.0) {
            numericProg = numericProg * 100
          }
          const effectiveChildProg = Math.max(0, Math.min(100, Math.round(numericProg)))
          if (existingJob.childResults[childId]) {
            existingJob.childResults[childId].progress = effectiveChildProg
          }
          const expectedOutputs = existingJob.meta?.outputs || (Array.isArray(existingJob.childIds) && existingJob.childIds.length > 0 ? existingJob.childIds.length : 1)
          if (expectedOutputs > 1) {
            let sum = 0
            if (existingJob.childIds && existingJob.childIds.length > 0) {
              existingJob.childIds.forEach((cId) => {
                sum += (existingJob.childResults?.[cId]?.progress || 0)
              })
            } else {
              Object.values(existingJob.childResults).forEach((c) => {
                sum += (c.progress || 0)
              })
            }
            existingJob.progress = Math.max(0, Math.min(99, Math.round(sum / Math.max(1, expectedOutputs))))
          } else {
            existingJob.progress = effectiveChildProg >= 100 ? (existingJob.status === 'completed' ? 100 : 99) : effectiveChildProg
          }
        }
      }
      existingJob.updatedAt = Date.now()

      if (Array.isArray(existingJob.childIds) && existingJob.childIds.length > 0) {
        const total = existingJob.childIds.length
        const results = Object.values(existingJob.childResults)
        const completedCount = results.filter(r => r.resultUrl || r.status === 'completed').length
        const failedCount = results.filter(r => r.status === 'failed' || r.progress === -1).length

        if (completedCount + failedCount >= total) {
          if (completedCount > 0) {
            existingJob.status = 'completed'
            existingJob.progress = 100
            existingJob.statusMessage = 'Processing complete'
            existingJob.output_url = results.find(r => r.resultUrl)?.resultUrl || existingJob.output_url
          } else {
            existingJob.status = 'failed'
            existingJob.statusMessage = 'Generation failed'
          }
        }
      }
      saveJobsToStorage(state.activeJobs)
    },

    dismissJob: (state, action) => {
      const payload = action.payload
      const targetId = typeof payload === 'object' && payload !== null ? (payload?.jobId || payload?.id || payload?.generationId) : payload
      const force = typeof payload === 'object' && payload !== null ? Boolean(payload?.force) : false
      if (!targetId) return
      if (state.activeJobs[targetId]) {
        if (!force && (state.activeJobs[targetId].status === 'queued' || state.activeJobs[targetId].status === 'processing')) {
          return
        }
        state.activeJobs[targetId].dismissed = true
        state.activeJobs[targetId].viewed = true
      } else {
        const foundKey = Object.keys(state.activeJobs).find((key) => {
          const j = state.activeJobs[key]
          return (
            j.jobId === targetId ||
            j.generationId === targetId ||
            j.id === targetId ||
            (Array.isArray(j.childIds) && j.childIds.includes(targetId))
          )
        })
        if (foundKey && state.activeJobs[foundKey]) {
          if (!force && (state.activeJobs[foundKey].status === 'queued' || state.activeJobs[foundKey].status === 'processing')) {
            return
          }
          state.activeJobs[foundKey].dismissed = true
          state.activeJobs[foundKey].viewed = true
        }
      }
      saveJobsToStorage(state.activeJobs)
    },

    markJobViewed: (state, action) => {
      const target = action.payload
      if (!target) return
      if (state.activeJobs[target]) {
        if (state.activeJobs[target].status === 'queued' || state.activeJobs[target].status === 'processing') {
          return
        }
        state.activeJobs[target].viewed = true
        state.activeJobs[target].dismissed = true
      } else {
        const foundKey = Object.keys(state.activeJobs).find((key) => {
          const j = state.activeJobs[key]
          return j.jobId === target || j.generationId === target || j.id === target
        })
        if (foundKey && state.activeJobs[foundKey]) {
          if (state.activeJobs[foundKey].status === 'queued' || state.activeJobs[foundKey].status === 'processing') {
            return
          }
          state.activeJobs[foundKey].viewed = true
          state.activeJobs[foundKey].dismissed = true
        } else {
          const meta = getToolMetadata(target)
          const targetToolName = meta?.tool_name || String(target).toLowerCase()
          Object.keys(state.activeJobs).forEach((key) => {
            const j = state.activeJobs[key]
            if (j.status === 'queued' || j.status === 'processing') return
            if (
              j.tool_name === targetToolName ||
              j.tool_name === target ||
              getToolMetadata(j.tool_name)?.tool_name === targetToolName
            ) {
              j.viewed = true
              j.dismissed = true
            }
          })
        }
      }
      saveJobsToStorage(state.activeJobs)
    },

    removeJob: (state, action) => {
      const targetId = action.payload
      if (!targetId) return
      if (state.activeJobs[targetId]) {
        if (state.activeJobs[targetId].status === 'queued' || state.activeJobs[targetId].status === 'processing') {
          return
        }
        delete state.activeJobs[targetId]
      } else {
        const foundKey = Object.keys(state.activeJobs).find((key) => {
          const j = state.activeJobs[key]
          return j.jobId === targetId || j.generationId === targetId || j.id === targetId
        })
        if (foundKey) {
          if (state.activeJobs[foundKey].status === 'queued' || state.activeJobs[foundKey].status === 'processing') {
            return
          }
          delete state.activeJobs[foundKey]
        }
      }
      saveJobsToStorage(state.activeJobs)
    },

    removeCompletedJobByTool: (state, action) => {
      const toolIdentifier = action.payload
      if (!toolIdentifier) return
      const meta = getToolMetadata(toolIdentifier)
      const targetToolName = meta?.tool_name || String(toolIdentifier).toLowerCase()

      Object.keys(state.activeJobs).forEach((key) => {
        const job = state.activeJobs[key]
        if (job && job.status === 'completed') {
          const jobMeta = getToolMetadata(job.tool_name)
          if (
            job.tool_name === targetToolName ||
            jobMeta?.tool_name === targetToolName ||
            job.tool_name === toolIdentifier ||
            job.ai_tool_id === toolIdentifier ||
            (meta?.route && jobMeta?.route === meta.route)
          ) {
            delete state.activeJobs[key]
          }
        }
      })
      saveJobsToStorage(state.activeJobs)
    },

    removeToolJobs: (state, action) => {
      const toolIdentifier = action.payload
      if (!toolIdentifier) return
      const meta = getToolMetadata(toolIdentifier)
      const targetToolName = meta?.tool_name || String(toolIdentifier).toLowerCase().replace(/[\s\-_]+/g, '_')

      Object.keys(state.activeJobs).forEach((key) => {
        const job = state.activeJobs[key]
        if (!job) return
        if (job.status === 'queued' || job.status === 'processing') {
          return
        }
        const jobMeta = getToolMetadata(job.tool_name)
        const jobToolName = jobMeta?.tool_name || String(job.tool_name || '').toLowerCase().replace(/[\s\-_]+/g, '_')
        if (
          job.tool_name === targetToolName ||
          jobToolName === targetToolName ||
          job.tool_name === toolIdentifier ||
          job.ai_tool_id === toolIdentifier ||
          (meta?.route && jobMeta?.route === meta.route)
        ) {
          delete state.activeJobs[key]
        }
      })
      saveJobsToStorage(state.activeJobs)
    },

    cancelToolJobs: (state, action) => {
      const payload = action.payload
      const toolIdentifier = typeof payload === 'object' && payload !== null
        ? (payload?.tool_name || payload?.toolName || payload?.ai_tool_id || payload?.tool)
        : payload
      if (!toolIdentifier) return
      const meta = getToolMetadata(toolIdentifier)
      const targetToolName = meta?.tool_name || String(toolIdentifier).toLowerCase().replace(/[\s\-_]+/g, '_')
      const targetCanonical = resolveToolId(toolIdentifier) || resolveToolId(meta?.route)

      Object.keys(state.activeJobs).forEach((key) => {
        const job = state.activeJobs[key]
        if (!job) return
        const jobCanonical = resolveToolId(job.ai_tool_id) || resolveToolId(job.tool_name) || resolveToolId(job.targetUrl)
        const jobMeta = getToolMetadata(job.tool_name)
        const jobToolName = jobMeta?.tool_name || String(job.tool_name || '').toLowerCase().replace(/[\s\-_]+/g, '_')
        if (
          (targetCanonical && jobCanonical && targetCanonical === jobCanonical) ||
          job.tool_name === targetToolName ||
          jobToolName === targetToolName ||
          job.tool_name === toolIdentifier ||
          job.ai_tool_id === toolIdentifier ||
          (meta?.route && jobMeta?.route === meta.route)
        ) {
          job.dismissed = true
          job.viewed = true
          job.status = 'failed'
          delete state.activeJobs[key]
        }
      })
      saveJobsToStorage(state.activeJobs)
    },

    dismissAllJobs: (state) => {
      Object.keys(state.activeJobs).forEach((id) => {
        if (state.activeJobs[id].status === 'queued' || state.activeJobs[id].status === 'processing') {
          return
        }
        state.activeJobs[id].dismissed = true
        state.activeJobs[id].viewed = true
      })
      saveJobsToStorage(state.activeJobs)
    },

    toggleQueueDrawer: (state) => {
      state.isDrawerExpanded = !state.isDrawerExpanded
    },

    setQueueDrawer: (state, action) => {
      state.isDrawerExpanded = Boolean(action.payload)
    },

    clearDismissedJobs: (state) => {
      Object.keys(state.activeJobs).forEach((id) => {
        if (state.activeJobs[id].dismissed) {
          delete state.activeJobs[id]
        }
      })
      saveJobsToStorage(state.activeJobs)
    },

    clearAllJobs: (state) => {
      state.activeJobs = {}
      if (typeof window !== 'undefined') {
        try {
          localStorage.removeItem('active_jobs_persist_v1')
          localStorage.removeItem('activeJobs')
        } catch (e) {}
      }
      saveJobsToStorage(state.activeJobs)
    }
  }
})

export const {
  registerJob,
  updateJobFromSSE,
  updateJobChild,
  dismissJob,
  dismissAllJobs,
  markJobViewed,
  removeJob,
  removeCompletedJobByTool,
  removeToolJobs,
  cancelToolJobs,
  toggleQueueDrawer,
  setQueueDrawer,
  clearDismissedJobs,
  clearAllJobs
} = jobsSlice.actions

export default jobsSlice.reducer
